// extracted by mini-css-extract-plugin
export default {"flexContainer":"NftPrice_flexContainer__5drJh","withDescriptionContainer":"NftPrice_withDescriptionContainer__EoFEG","withInfoIconContainer":"NftPrice_withInfoIconContainer__zohRT"};